// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"131":"58aedf23","194":"f2f8528e","260":"86aad8f2","668":"c39b2fc8","675":"8d16ce7e","762":"e60ce72a","811":"5fb4ee99","902":"294a4de7","973":"bb7a29b7","983":"53620673"}[chunkId] + ".js";
};